<template>
  <div class="register-page" v-slideIn>
    <div class="page-head-container">
      <PageHead pageName="找回密码"/>
    </div>
    <div class="form-area">
      <div>
        <Input
          placeholder="手机号"
          name="phone"
          v-model="phone"
          :error="phoneError"
          @input="handlePhoneInput"
        />
      </div>
      <div>
        <Input
          placeholder="短信验证码"
          maxlength="4"
          name="smsCode"
          v-model="smsCode"
          :error="smsCodeError"
          @input="handleSmsCodeInput"
        />
        <span class="get-smscode">
          <Countdown :onClick="getSmsCode" text="获取验证码"/>
        </span>
      </div>
      <div>
        <Input
          :type="passwordInputType"
          placeholder="密码"
          name="password"
          v-model="password"
          :error="passwordError"
          @input="handlePasswordInput"
        />
        <img
          :src="showPassword ? visibleImg : invisibleImg"
          @click="handleEyeClick"
          class="eye-img"
        >
      </div>
      <div>
        <Input
          type="password"
          placeholder="重复密码"
          name="repeatPassword"
          v-model="repeatPassword"
          :error="repeatPasswordError"
          @input="handleRepeatPasswordInput"
        />
      </div>
      <div class="img-code-field-wrapper">
        <Input
          placeholder="图片验证码"
          maxlength="4"
          name="imgCode"
          v-model="imgCode"
          @input="handleImgCodeInput"
          :error="imgCodeError"
          @keyup="handleKeyUp"
        />
        <span class="get-imgCode">
          <img :src="imgCodeUrl" @click="refreshImgCode">
        </span>
      </div>

      <div class="button">
        <Button text="确认" type="success" :onClick="handleResetPassword"></Button>
      </div>
      <div class="button">
        <Button text="返回登录" :onClick="goToLogin"></Button>
      </div>
    </div>

    <div class="operate-container">
      <div class="intro">为工业4.0而生</div>
    </div>
  </div>
</template>
<script>
import Input from '@/components/Input/index.vue'
import Button from '@/components/Button/index.vue'
import Countdown from '@/components/Countdown/index.vue'
import PageHead from '@/components/PageHead/index.vue'
import api from '@/api'
import Message from '@/components/Message'
import visibleImg from '@/assets/visible.png'
import invisibleImg from '@/assets/invisible.png'

export default {
  name: 'c-register',
  data() {
    return {
      visibleImg,
      invisibleImg,
      showPassword: false,
      passwordInputType: 'password',
      imgCodeUrl: '/api/v1/randCode',

      phone: '',
      smsCode: '',
      password: '',
      repeatPassword: '',
      imgCode: '',

      phoneError: '',
      smsCodeError: '',
      passwordError: '',
      repeatPasswordError: '',
      imgCodeError: ''
    }
  },
  created() {
      setTimeout(() => {
      let baseTitle = JSON.parse(localStorage.getItem('WEB_INFO')).title || '';
      document.title = `${baseTitle}找回密码`;
    }, 500);
  },
  methods: {
    refreshImgCode() {
      this.imgCodeUrl = this.imgCodeUrl.split('?')[0] + '?v=' + Math.random()
    },
    validatePhone() {
      let errorText = ''
      if (!this.phone) {
        errorText = '请输入手机号'
      } else if (!/^1[\d]{10}$/.test(this.phone)) {
        errorText = '手机号格式错误'
      }
      this.phoneError = errorText
      return !errorText
    },
    handlePhoneInput(v) {
      this.validatePhone()
    },
    handleEyeClick() {
      this.showPassword = !this.showPassword
      if (this.showPassword) {
        this.passwordInputType = 'text'
      } else {
        this.passwordInputType = 'password'
      }
    },
    validateSmsCode() {
      let errorText = ''
      if (!this.smsCode) {
        errorText = '请输入短信验证码'
      } else if (!/^[\d]{4}$/.test(this.smsCode)) {
        errorText = '短信验证码格式错误'
      }
      this.smsCodeError = errorText
      return !errorText
    },
    handleSmsCodeInput(v) {
      this.validateSmsCode()
    },
    validatePassword() {
      let reg = /^(?:(?=.*[A-Z])(?=.*[0-9]))[a-zA-Z0-9]{6,12}$/
      let errorText = ''
      if (!this.password) {
        errorText = '请输入密码'
      } else if (!reg.test(this.password)) {
        errorText = '6-12位数字字母组合，必须包含大写字母'
      }
      this.passwordError = errorText
      return !errorText
    },
    handlePasswordInput(v) {
      this.validatePassword()
    },
    validateRepeatPassword() {
      let errorText = ''
      if (!this.repeatPassword) {
        errorText = '两次密码输入不一致，请重新输入'
      }
      if (this.repeatPassword !== this.password) {
        errorText = '两次密码输入不一致，请重新输入'
      }
      this.repeatPasswordError = errorText
      return !errorText
    },
    validateImgCode() {
      let errorText = ''
      if (!this.imgCode) {
        errorText = '请输入图片验证码'
      } else if (!/^\d{4}$/.test(this.imgCode)) {
        errorText = '图片验证码格式错误'
      }
      this.imgCodeError = errorText
      return !errorText
    },
    handleRepeatPasswordInput(v) {
      this.validateRepeatPassword()
    },
    handleImgCodeInput(v) {
      this.validateImgCode()
    },
    handleKeyUp(e) {
      if (e.keyCode === 13) {
        this.handleResetPassword()
      }
    },
    validate() {
      return (
        this.validatePhone() &&
        this.validateSmsCode() &&
        this.validatePassword() &&
        this.validateRepeatPassword() &&
        this.validateImgCode()
      )
    },
    getSmsCode() {
      if (!this.validatePhone()) {
        return
      }
      return api
        .getResetPasswordSmsCode({
          phone: this.phone
        })
        .then(res => {
          if (res.code === 0) {
            // this.$refs.smsCodeInput.focus()
          }
          return res
        })
    },
    goToLogin() {
      this.$router.push({
        path: '/login',
        query: { ...this.$route.query }
      })
    },
    handleAcceptChange() {},
    handleResetPassword() {
      if (!this.validate()) {
        return
      }
      api
        .resetPassword({
          phone: this.phone,
          phoneCode: this.smsCode,
          password: this.password,
          platformCode: this.$route.query.platform_code,
          randCode: this.imgCode
        })
        .then(res => {
          if (res.code === 0) {
            Message.success('找回密码成功,正为您跳转登录页...')
            setTimeout(() => {
              this.goToLogin()
            }, 3000)
          } else {
            this.refreshImgCode()
          }
        })
    }
  },
  components: { Input, Button, Countdown, PageHead }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
